// Import dependencies
import React, {Component} from 'react';
import $ from 'jquery';

// Import css
import './Pagination.css';

// Define transition parameter
const translateY = ['0%', '-25%', '-50%', '-75%'];
const translateX = ['0px', '-70px', '-140px', '-210px'];
const animations = [
    ['is-active', 'is-active', 'is-just-after', 'is-after', 'is-after', 'is-after', 'is-after', 'is-after', 'is-after'],
    ['is-before', 'is-before', 'is-active', 'is-active', 'is-just-after', 'is-after', 'is-after', 'is-after', 'is-after'],
    ['is-before', 'is-before', 'is-before', 'is-before', 'is-active', 'is-active', 'is-just-after', 'is-after', 'is-after'],
    ['is-before', 'is-before', 'is-before', 'is-before', 'is-before', 'is-before', 'is-active', 'is-active', 'is-just-after']
];


export default class Pagination extends Component {
    constructor(props) {
        super(props);
        this.state = ({
            transitionAnim: ''
        });
        this.toggleTransition = this.toggleTransition.bind(this);
    }

    // Toggles transition animation
    toggleTransition() {
        // Highlight dashed box
        this.setState({ transitionAnim: 'is-transitionning' });
        // Make current slide blink
        let blinkIntr = setInterval(function() { $('#pagination__container').toggleClass('is-blinking'); }, 45);
        // Clear animations
        setTimeout( function() {
            this.setState({ transitionAnim: '' });
            clearInterval(blinkIntr);
            $('#pagination__container').removeClass('is-blinking');
        }.bind(this), 2300 );
    }

    // Listen to new props
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.currentSlide !== this.props.currentSlide) {
            this.toggleTransition();
        }
    }

    render() {
        return (
            <div
                data-v-707e2a6c=""
                id='pagination__container'
                className={ "pagination is-visible "+this.state.transitionAnim }
            >
                <div data-v-707e2a6c="" className="background" style={{ transform: 'translateY('+translateY[this.props.currentSlide]+')' }} />

                <div data-v-707e2a6c="" className="mover" style={{ transform: 'translateX('+translateX[this.props.currentSlide]+')' }}>

                    <div data-v-707e2a6c="" className={"index "+animations[this.props.currentSlide][0]} style={{ left: 0 }}>
                        <span data-v-707e2a6c="" className="inactive">01</span>
                        <span data-v-707e2a6c="" className="active">
                            <span data-v-707e2a6c="" className="blinker">01</span>
                        </span>
                    </div>
                    <div data-v-707e2a6c="" className={"stroke "+animations[this.props.currentSlide][1]} style={{ left: 35 }} />

                    <div data-v-707e2a6c="" className={"index "+animations[this.props.currentSlide][2]} style={{ left: 70 }}>
                        <span data-v-707e2a6c="" className="inactive">02</span>
                        <span data-v-707e2a6c="" className="active">
                            <span data-v-707e2a6c="" className="blinker">02</span>
                        </span>
                    </div>
                    <div data-v-707e2a6c="" className={"stroke "+animations[this.props.currentSlide][3]} style={{ left: 105 }} />

                    <div data-v-707e2a6c="" className={"index "+animations[this.props.currentSlide][4]} style={{ left: 140 }}>
                        <span data-v-707e2a6c="" className="inactive">03</span>
                        <span data-v-707e2a6c="" className="active">
                            <span data-v-707e2a6c="" className="blinker">03</span>
                        </span>
                    </div>
                    <div data-v-707e2a6c="" className={"stroke "+animations[this.props.currentSlide][5]} style={{ left: 175 }} />

                    <div data-v-707e2a6c="" className={"index "+animations[this.props.currentSlide][6]} style={{ left: 210 }}>
                        <span data-v-707e2a6c="" className="inactive">04</span>
                        <span data-v-707e2a6c="" className="active">
                            <span data-v-707e2a6c="" className="blinker">04</span>
                        </span>
                    </div>

                    <div data-v-707e2a6c="" className={"stroke "+animations[this.props.currentSlide][7]} style={{ left: 245 }} />

                    <div data-v-707e2a6c="" className={"index "+animations[this.props.currentSlide][8]} style={{ left: 280 }}>
                        <span data-v-707e2a6c="" className="inactive">00</span>
                        <span data-v-707e2a6c="" className="active">
                            <span data-v-707e2a6c="" className="blinker">05</span>
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}
